/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDFiles' store object.
 * @namespace SDFilesSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDFiles';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDFilesSelectors
   */
  static postSdUploadDocument = state =>
    state[selectors.moduleIdentifier].postSdUploadDocument.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDFilesSelectors
   */
  static isFetchingPostSdUploadDocument = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdUploadDocument.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDFilesSelectors
   */
  static postSdUploadDocumentError = state =>
    state[selectors.moduleIdentifier].postSdUploadDocumentError.payload;
}
